import React, { ComponentProps, FC, useEffect } from 'react';
import AdvancedModal from '@tovia/man-ui/lib/components/Modal/AdvancedModal';
import { useLocation } from 'react-router-dom';
import { addDashesToUUID } from '@tovia/man-app-utils/lib/helpers/uuids';
import { useSelector } from '../../redux';
import { UpgradeNoEnterDialog } from './UpgradeNoEnterDialog';
import { UpgradeFreeMonthDialog } from './UpgradeFreeMonth';
import { UpgradePurchaseDialog } from './UpgradePurchaseDialog';
import { Biller, DataSource } from 'src/shared/constants/billers';
import { UpgradeModal } from './UpgradeModal';
import { UpgradeButton } from './UpgradeButton';
import { useJoinUrl } from '../buttons/JoinButton';

type Props = {
  eventTrigger: string;
} & ComponentProps<typeof AdvancedModal>;

export const UpgradeDialog: FC<Props> = (props) => {
  const { eventTrigger, ...rest } = props;
  const config = useSelector((state) => state.app.config);
  const site = useSelector((state) => state.site);
  const user = useSelector((state) => state.auth.user);
  const location = useLocation();
  const [joinUrl] = useJoinUrl({ campaign: 'upgrade-dialog' });

  useEffect(() => {
    if (props.show) {
      window.dataLayer.push({
        event: 'gaEvent',
        eventCategory: 'member-action',
        eventAction: eventTrigger,
        eventLabel: location.pathname,
      });
    }
  }, [props.show, eventTrigger, location.pathname]);

  const existingSubscription = !!user?.subscriptions.find(
    (sub) =>
      sub.siteUUID === addDashesToUUID(site.UUID) &&
      sub.billerID === Biller.RocketGate &&
      [DataSource.Processor, DataSource.Migration].includes(+sub.dataSourceID),
  );

  const canUpgrade = existingSubscription && user?.validSubscription;

  if (canUpgrade) {
    return <UpgradePurchaseDialog {...rest} />;
  }

  if (config.freeMonthUpgradePromo) {
    return <UpgradeFreeMonthDialog {...rest} />;
  }

  if (config.useNonEnterModal) {
    return <UpgradeNoEnterDialog {...rest} />;
  }

  return (
    <UpgradeModal {...rest}>
      <p>We&apos;re sorry - You have reached the download limit for your trial account.</p>
      <p>For unlimited downloads please upgrade to a premium membership</p>
      <UpgradeButton url={joinUrl} target="_top">
        Enter Here
      </UpgradeButton>
    </UpgradeModal>
  );
};
